// src/screens/auth/LegalScreen.js
// 74차: 신규 생성 — 이용약관/개인정보처리방침을 외부 WebView(실제 사이트)로 열던 것을
//       홈 화면처럼 앱 안의 라우트 화면으로 전환. 기존 WebView 방식은 (1) 실제
//       이용약관 전용 페이지가 사이트에 없어 개인정보처리방침과 같은 URL을 공유해
//       "이용약관 보기"를 눌러도 다른 내용이 뜨는 문제, (2) 페이지 안 링크를 누르면
//       새 화면이 여닫히듯 이탈하는 문제가 있었음.
// 78차 25차: 사용자 요청으로 전면 재작성 — 기존 문서(78차 이전)는 앱 안에 노출돼있던
// 정책 문구를 그러모은 초안이라 아래 문제가 있었음: (1) 개인정보 보호책임자 이름/연락처
// 누락(개인정보보호법 필수 기재 항목), (2) "회원 탈퇴로 개인정보 삭제 요청 가능"이라고
// 돼 있었는데 이 앱엔 회원탈퇴 기능 자체가 없어 실제 기능과 불일치 — "고객센터(앱 문의)를
// 통한 삭제 요청"으로 실제 동작에 맞게 수정, (3) 시행일자 없음, (4) 이 앱의 백엔드가
// Firebase(Google Cloud, 해외 서버)라 개인정보 국외 이전 고지가 필요한데 누락돼 있었음,
// (5) FCM 푸시 토큰(기기 식별 정보) 수집 고지 누락, (6) 회사가 계약 당사자가 아니라
// 통신판매중개자라는 지위가 약관에 명확히 안 돼 있어 매장-고객 분쟁 시 책임 범위가 불분명.
// ⚠️ 여전히 사용자가 직접 작성한 초안이며 법률 검토를 거치지 않음 — 실제 서비스 운영
// 전에는 변호사 검토가 필요함. [대괄호] 표시된 부분은 실제 사업자 정보로 채워야 함.
// 78차 72차: 사업자등록증 발급 확인 후 상호/대표자/사업장 주소/사업자등록번호/개인정보
// 보호책임자 성명·연락처를 실제 값으로 채움. 이메일과 통신판매업 신고번호(신고 완료 후
// 기재)만 아직 미기재. 동종업계(방탈출 예약 플랫폼) 약관 조사 결과 빠져있던 4개 조항
// (미성년자 법정대리인 동의/청약철회/저작권 귀속/손해배상)을 신규 추가, 이후 조 번호를
// 한 칸씩 순연. LAST_UPDATED를 2026-07-23으로 갱신.
// 78차 78차: 통신판매업 신고 확인증 발급 완료 — 신고번호(제 2026-서울동대문-1357호) 반영.
// 78차 79차: 이메일 주소(contact@unlockapp.co.kr) 반영 — 사업자 정보 [대괄호] 미기재 항목
// 전부 채워짐.

import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';
import { COLORS } from '../../constants/theme';
import AppHeader from '../../components/common/AppHeader';

const GOLD       = COLORS.gold;
const BG         = COLORS.bg;
const TEXT       = COLORS.text;
const TEXT_SEC   = COLORS.textSec;
const TEXT_MUTED = 'rgba(255,255,255,0.35)';

// 80차 후속: [법률 검토] 이번 세션에 새로 추가된 "만 19세 이상만 예약 가능한 테마"
// 기능(생년월일 기반 연령 확인)이 약관/개인정보처리방침 어디에도 반영돼 있지 않았음 —
// 개인정보처리방침의 "수집하는 개인정보 항목"엔 생년월일 자체가 아예 빠져 있었고
// (개인정보보호법상 수집항목·목적 고지 의무 위반 소지), 이용약관에도 일부 테마에
// 연령 제한이 있을 수 있다는 설명이 없었음 — 둘 다 반영.
// 80차 후속: [날짜 정리] 정식 오픈 예정일(2026-09-01)이 확정됨에 따라, 아직 실사용자가
// 없는 개발 단계 동안 조항이 추가/수정될 때마다 각각 다른 "적용일"을 기록해오던 것을
// 전부 오픈일 하나로 통일 — 실제로 이 약관에 구속되는 회원이 생기는 시점은 오픈일부터라,
// 그 전까지의 여러 수정 시점을 각각 명시하는 게 의미가 없음.
// 80차 계속: 정식 오픈 예정일을 2026-10-01로 재조정(제휴 영업 일정 여유 확보 목적) —
// 위와 동일한 이유로 날짜만 한 곳(LAST_UPDATED)과 부칙 2곳을 갱신하면 됨.
const LAST_UPDATED = '2026-10-01';

const TERMS_SECTIONS = [
  // 78차: 전자상거래법 제10조는 통신판매(중개)업자가 상호/대표자/사업장 주소/연락처/
  // 사업자등록번호/통신판매업 신고번호를 이용자가 쉽게 볼 수 있는 곳에 표시하도록 요구함 —
  // 지금까지 이 약관 어디에도 이 항목들을 담을 자리 자체가 없었음(78차25차 재작성 때도
  // 누락). [대괄호]는 전부 실제 사업자 정보로 채워야 하는 자리 — 사업자등록증 발급 후
  // 정확한 값으로 교체 필요.
  { h: '사업자 정보', b: '상호(회사명): 언락(UNLOCK)\n대표자: 노재현\n사업장 소재지: 서울시 동대문구 황물로 168, 418호\n전화번호: 010-6886-5147\n이메일: contact@unlockapp.co.kr\n사업자등록번호: 863-69-00714\n통신판매업 신고번호: 제 2026-서울동대문-1357호' },
  { h: '제1조 (목적)', b: '이 약관은 언락(UNLOCK)(이하 "회사")이 운영하는 방탈출 매장 예약 중개 서비스 "UNLOCK"(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.' },
  { h: '제2조 (정의)', b: '① "회원"이란 이 약관에 동의하고 서비스에 가입한 자를 말합니다.\n② "매장"이란 서비스를 통해 예약 정보를 노출하고 방탈출 테마를 제공하는 사업자를 말합니다.\n③ "예약"이란 회원이 매장의 특정 테마·일시를 예약 의사로 등록하는 행위를 말합니다.\n④ "포인트"란 서비스 이용에 따라 회사가 회원에게 지급하는 서비스 내 전용 적립금을 말합니다.' },
  { h: '제3조 (회사의 지위 — 통신판매중개자)', b: '회사는 회원과 매장 간의 예약이 원활히 이루어지도록 정보통신서비스를 제공하는 통신판매중개자이며, 회원과 매장 간 체결되는 거래(테마 이용 계약)의 당사자가 아닙니다. 회사는 통신판매중개자로서 매장이 등록한 정보의 진위 여부를 보증하지 않으며, 매장이 제공하는 서비스(테마 이용, 현장 응대 등)와 관련하여 발생하는 책임은 원칙적으로 해당 매장에 있습니다.' },
  { h: '제4조 (약관의 게시와 개정)', b: '① 회사는 이 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 내 화면에 게시합니다.\n② 회사는 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있으며, 개정 시 적용일자 및 개정사유를 명시하여 적용일 7일 전(회원에게 불리한 변경은 30일 전)부터 서비스 내 공지사항을 통해 공지합니다.\n③ 회원이 개정 약관에 동의하지 않는 경우 서비스 이용을 중단하고 탈퇴를 요청할 수 있습니다. 공지 후에도 계속 서비스를 이용하면 개정 약관에 동의한 것으로 봅니다.' },
  // 78차 72차: 동종업계(빠방/잼핏) 약관 조사 결과 UNLOCK에 빠져있던 4개 조항(미성년자
  // 법정대리인 동의/청약철회/저작권 귀속/손해배상) 추가 — 이후 조항 번호를 전부 한 칸씩
  // 순연시킴(제7조 청약철회, 제10조 저작권, 제14조 손해배상 신규 삽입).
  { h: '제5조 (회원가입)', b: '① 회원가입은 만 14세 이상만 가능합니다.\n② 이메일 또는 카카오톡·네이버·Google·Apple 계정 연동을 통해 가입 신청을 하며, 회사가 이를 승낙함으로써 회원가입이 완료됩니다.\n③ 다음 각 호에 해당하는 경우 회사는 가입 신청을 거부하거나 사후에 이용계약을 해지할 수 있습니다: 타인의 명의를 도용한 경우, 허위 정보를 기재한 경우, 만 14세 미만인 경우, 이전에 이용 제재를 받은 이력이 있는 경우.\n④ 회원이 미성년자인 경우 법정대리인의 동의를 받아야 하며, 법정대리인의 동의 없이 체결된 이용계약은 미성년자 본인 또는 법정대리인이 이를 취소할 수 있습니다.' },
  // 78차: 기존 문구가 "24시간 전까지 무료 취소, 이후엔 매장 정책 적용"이라고 되어 있었는데
  // 실제 코드(cancelReservation)엔 그런 시간 기준 제한이나 위약금 처리 로직이 전혀
  // 없음(전수조사 중 대조 확인) — 약관과 실제 동작이 다르면 그 자체로 문제가 될 수 있어
  // 실제 동작(언제든 취소 가능, 반복 노쇼만 별도 제재)에 맞게 수정.
  { h: '제6조 (예약 및 취소, 노쇼)', b: '① 서비스에서의 "예약"은 회원이 매장에 방문·이용 의사를 전달하는 것이며, 실제 결제는 매장 현장 또는 매장이 별도로 지정한 결제 수단을 통해 이루어집니다(서비스 내 별도 결제 기능이 도입되는 경우 이 조항은 갱신됩니다).\n② 예약 취소는 예약 시각 전까지 앱 내에서 위약금 없이 직접 처리할 수 있습니다. 다만 반복적인 노쇼(예약 후 미방문) 또는 임박한 취소가 누적되는 경우, 매장의 요청 및 서비스 정책에 따라 일정 기간 모집글 작성 등 서비스 이용이 제한될 수 있습니다.\n③ 매장의 사정(휴업 등)으로 예약 이행이 불가능한 경우 회사는 회원에게 이를 고지하도록 매장에 요청하며, 이로 인해 발생한 손해에 대한 1차적 책임은 매장에 있습니다.\n④ 일부 테마는 콘텐츠 특성(공포 등)에 따라 만 19세 이상만 예약할 수 있으며, 이 경우 회원이 프로필에 입력한 생년월일을 기준으로 예약 가능 여부가 제한됩니다. 생년월일을 등록하지 않은 회원은 해당 테마를 예약할 수 없습니다.' },
  { h: '제7조 (청약철회)', b: '① 회원은 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조에 따라 예약(청약) 후 청약철회를 요청할 수 있습니다.\n② 다만 예약일이 이미 도래하여 매장에서의 서비스 제공이 개시된 경우에는 같은 법 제17조제2항에 따라 청약철회가 제한될 수 있습니다.\n③ 예약 취소의 구체적인 절차와 기준은 제6조에 따릅니다.' },
  { h: '제8조 (포인트)', b: '① 회원가입, 리뷰 작성 등 서비스 이용에 따라 지급되는 포인트는 적립일로부터 1년간 유효하며, 유효기간이 지난 포인트는 사전 통지 후 자동 소멸됩니다.\n② 포인트는 현금으로 환급되지 않으며, 부정한 방법으로 적립되었거나 이용약관을 위반하여 적립된 포인트는 사전 통지 없이 회수될 수 있습니다.' },
  { h: '제9조 (회원의 의무)', b: '회원은 다음 행위를 하여서는 안 됩니다: 타인의 정보 도용, 허위 정보 등록, 서비스를 이용한 영리 목적의 무단 광고, 매장 또는 다른 회원에게 피해를 주는 행위, 모집 게시판·리뷰 등에 허위 사실 또는 명예훼손성 내용을 게시하는 행위. 이를 위반한 경우 서비스 이용이 제한되거나 이용계약이 해지될 수 있습니다.' },
  { h: '제10조 (저작권의 귀속 및 이용제한)', b: '① 회원이 서비스 내에 게시한 리뷰, 모집글, 댓글 등 콘텐츠에 대한 저작권은 이를 작성한 회원에게 있습니다.\n② 회원은 서비스 내에 게시한 콘텐츠를 회사가 서비스의 운영, 홍보, 개선 목적의 범위 내에서 편집·전시·전송하는 것을 허락한 것으로 봅니다.\n③ 회원은 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송, 그 밖의 방법으로 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.' },
  { h: '제11조 (서비스의 변경 및 중단)', b: '회사는 운영상, 기술상 필요에 따라 서비스의 전부 또는 일부를 변경하거나 중단할 수 있으며, 이 경우 사전에 공지합니다. 다만 긴급한 시스템 점검 등 부득이한 경우 사후에 공지할 수 있습니다.' },
  { h: '제12조 (계약 해지 및 이용 제한)', b: '① 회원은 마이페이지 내 "회원 탈퇴" 기능을 통해 언제든지 직접 탈퇴할 수 있으며, 탈퇴 즉시 처리됩니다.\n② 회사는 회원이 제9조를 위반하거나 매장·타 회원에게 피해를 끼친 경우 사전 통지 후 이용을 제한하거나 이용계약을 해지할 수 있습니다.' },
  { h: '제13조 (개인정보의 보호)', b: '회사는 관련 법령 및 회사의 개인정보처리방침에 따라 회원의 개인정보를 보호합니다. 자세한 내용은 개인정보처리방침을 참고해주세요.' },
  { h: '제14조 (손해배상)', b: '회사는 회사의 고의 또는 과실로 회원에게 손해가 발생한 경우 관련 법령에 따라 그 손해를 배상합니다. 다만 회원의 귀책사유로 발생한 손해이거나 제15조(면책조항)에 해당하는 경우에는 그러하지 아니합니다.' },
  { h: '제15조 (면책조항)', b: '① 회사는 천재지변, 불가항력적 사유로 서비스를 제공할 수 없는 경우 책임이 면제됩니다.\n② 회사는 매장이 제공하는 서비스의 내용, 품질, 현장 안전관리에 대해 책임을 지지 않으며, 이는 제3조(회사의 지위)에 따릅니다.\n③ 회사는 회원 간, 회원과 매장 간에 서비스를 매개로 발생한 분쟁에 개입하지 않으며, 이로 인한 손해를 배상할 책임이 없습니다. 다만 회사는 원활한 분쟁 해결을 위해 합리적인 범위에서 협조합니다.' },
  { h: '제16조 (분쟁해결 및 준거법)', b: '이 약관과 관련하여 회사와 회원 간에 분쟁이 발생한 경우 상호 협의하여 해결하는 것을 원칙으로 하며, 협의가 이루어지지 않는 경우 민사소송법상의 관할법원에 소를 제기할 수 있습니다. 이 약관은 대한민국 법령에 따라 해석·적용됩니다.' },
  { h: '부칙', b: '이 약관은 2026년 10월 1일(서비스 정식 오픈일)부터 적용됩니다.' },
];

const PRIVACY_SECTIONS = [
  { h: '1. 수집하는 개인정보 항목', b: '- 이메일 가입: 이메일 주소, 비밀번호(암호화 저장), 닉네임\n- 소셜 로그인(카카오톡/네이버/Google/Apple): 이메일, 닉네임, 프로필 이미지(제공 동의 시)\n- 프로필 설정 시 선택 입력: 생년월일(연령 확인 목적), 성별, 한줄소개\n- 서비스 이용 과정에서 생성: 예약 내역, 리뷰, 포인트 적립·사용 내역, 모집글 작성 내역, 문의 내역\n- 기기 정보: 푸시 알림 발송을 위한 기기 푸시 토큰(FCM/Expo Push Token)\n- 자동 수집 항목: 접속 로그, 서비스 이용 기록 (부정 이용 방지 목적)' },
  { h: '2. 개인정보의 수집 및 이용 목적', b: '회원 식별 및 로그인, 예약 처리 및 매장과의 예약 정보 연동, 만 19세 이상만 이용 가능한 테마에 대한 연령 확인, 포인트 적립·사용 관리, 리뷰·모집 게시판 등 서비스 제공, 공지사항 및 예약 관련 푸시 알림 발송, 부정 이용 방지 및 분쟁 처리를 위해 이용합니다.' },
  { h: '3. 개인정보의 보유 및 이용 기간', b: '회원 탈퇴(삭제 요청) 시 지체 없이 파기하는 것을 원칙으로 합니다. 다만 관계 법령에 따라 보존이 필요한 다음 정보는 해당 기간 동안 보관합니다.\n- 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)\n- 소비자 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)\n- 서비스 이용 기록, 접속 로그: 3개월 (통신비밀보호법)' },
  { h: '4. 개인정보의 제3자 제공', b: '회사는 원칙적으로 회원의 개인정보를 외부에 제공하지 않습니다. 다만 예약 처리를 위해 예약 정보(닉네임, 연락 가능 정보, 날짜, 시간, 인원)가 예약 대상 매장에 제공되며, 법령에 근거하거나 회원의 동의가 있는 경우를 제외하고 그 외 제3자에게 제공하지 않습니다.' },
  { h: '5. 개인정보 처리의 위탁 및 국외 이전', b: '회사는 서비스 제공을 위해 아래와 같이 개인정보 처리 업무를 위탁하고 있으며, 이 과정에서 개인정보가 국외로 이전됩니다.\n- 수탁자: Google LLC (Firebase / Google Cloud Platform)\n- 이전 국가: 미국 등 Google Cloud 데이터센터 소재국\n- 이전 항목: 제1항에 기재된 전체 개인정보\n- 이전 목적: 데이터베이스 호스팅, 인증, 푸시 알림 발송 등 서비스 인프라 운영\n- 이전 방법: 네트워크를 통한 전송 및 저장\n관련 법령이 정하는 안전성 확보조치를 다한 사업자(Google)를 통해 처리되며, 자세한 사항은 Google의 개인정보처리방침을 통해 확인하실 수 있습니다.' },
  { h: '6. 회원의 권리와 행사방법', b: '회원은 언제든지 마이페이지에서 본인의 개인정보를 조회·수정할 수 있습니다. 회원 탈퇴는 마이페이지 내 "회원 탈퇴" 기능을 통해 직접 처리할 수 있으며, 탈퇴 즉시 개인정보를 파기합니다(제3항의 법정 보존 기간이 있는 정보는 예외).' },
  { h: '7. 개인정보의 파기 절차 및 방법', b: '개인정보는 보유 기간이 경과하거나 처리 목적이 달성된 경우 지체 없이 파기합니다. 전자적 파일은 복구할 수 없는 방법으로 영구 삭제하며, 종이 문서는 분쇄하거나 소각합니다.' },
  { h: '8. 개인정보 보호책임자', b: '회사는 개인정보 처리에 관한 업무를 총괄하고 회원의 불만처리 및 피해구제를 위해 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.\n- 성명: 노재현\n- 연락처: 010-6886-5147\n문의하기(앱 내 고객센터)를 통해서도 개인정보 관련 문의를 접수하실 수 있습니다.' },
  { h: '9. 만 14세 미만 아동의 가입 제한', b: '서비스는 만 14세 이상만 가입할 수 있으며, 만 14세 미만 아동의 개인정보는 수집하지 않습니다.' },
  { h: '10. 개인정보처리방침의 변경', b: '이 개인정보처리방침은 법령·정책 변경에 따라 개정될 수 있으며, 변경 시 서비스 내 공지사항을 통해 사전 안내합니다.' },
  { h: '부칙', b: '이 개인정보처리방침은 2026년 10월 1일(서비스 정식 오픈일)부터 적용됩니다.' },
];

function LegalDocScreen({ title, sections }) {
  return (
    <View style={s.container}>
      <AppHeader showBack centerElement={<Text style={s.headerTitle} numberOfLines={1}>{title}</Text>} />
      <ScrollView contentContainerStyle={s.body} showsVerticalScrollIndicator={false}>
        <Text style={s.updated}>최종 업데이트: {LAST_UPDATED}</Text>
        {sections.map((sec) => (
          <View key={sec.h} style={s.section}>
            <Text style={s.sectionTitle}>{sec.h}</Text>
            <Text style={s.sectionBody}>{sec.b}</Text>
          </View>
        ))}
      </ScrollView>
    </View>
  );
}

export function TermsScreen() {
  return <LegalDocScreen title="이용약관" sections={TERMS_SECTIONS} />;
}

export function PrivacyScreen() {
  return <LegalDocScreen title="개인정보처리방침" sections={PRIVACY_SECTIONS} />;
}

const s = StyleSheet.create({
  container:   { flex: 1, backgroundColor: BG },
  headerTitle: { color: TEXT, fontSize: 15, fontWeight: '800' },
  body:        { padding: 20, paddingBottom: 48 },
  updated:     { color: TEXT_MUTED, fontSize: 12, marginBottom: 20 },
  section:     { marginBottom: 22 },
  sectionTitle:{ color: GOLD, fontSize: 14, fontWeight: '800', marginBottom: 8 },
  sectionBody: { color: TEXT_SEC, fontSize: 13, lineHeight: 21 },
});
